import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResourcesListService } from '../../services/resources-list.service';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

export interface ResourcesListEmailControls {
  to: AbstractControl;
  // from: AbstractControl;
}

export interface ResourcesListEmailAsJson {
  to: string;
  // from: string;
}

@Component({
    selector: 'app-resources-list-email',
    templateUrl: './resources-list-email.component.html',
    styleUrls: ['./resources-list-email.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ResourcesListEmailComponent extends GlobalShadowStyleDirective implements OnInit {

  form: UntypedFormGroup;

  constructor(
    private resourcesListService: ResourcesListService,
    private dialogRef: MatDialogRef<ResourcesListEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      contentPath: string
    },
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar
  ) {
    super();
    this.form = this.fb.group({
      to: this.fb.control('', Validators.required),
      // from: this.fb.control('', Validators.required)
    });
  }

  get formControls(): ResourcesListEmailControls {
    return this.form as unknown as ResourcesListEmailControls;
  }

  get formValuesAsJson(): ResourcesListEmailAsJson {
    return this.form.value as unknown as ResourcesListEmailAsJson;
  }

  ngOnInit(): void {
  }

  async sendEmail(): Promise<any> {
    const isMember = false;
    const deliveryRecipient = this.formValuesAsJson.to;
    const etAttributes = [{
      name: 'Web Site Path',
      value: `https://${window.location.host}/${this.data.contentPath}`
    }];
    const response = await this.resourcesListService.sendDocumentInEmail(
      isMember, deliveryRecipient, etAttributes
    );

    if (!(response instanceof HttpErrorResponse)) {
      const alertDuration = 1000; // ms

      this.snackBar.open(`Successfully sent document.`, 'OK', {
        duration: alertDuration,
        panelClass: 'positive-panel-class'
      });

      setTimeout(() => {
        this.closeModal();
      }, alertDuration);
    } else {

    }

    return response;
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
